module.exports = __webpack_public_path__ + "abd7111d7a3871d7621f720784699448.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/tablet.png
// module id = 3055
// module chunks = 0